export default (node) => {
  /**
   * Data + elements
   */
  const addToCartButton = document.getElementById('add-to-cart-button');
  const popupAddToCartButton = node.querySelector('[data-add-to-cart-button]');
  const colorOption = node.querySelector('[data-option-color]');
  const lengthOption = node.querySelector('[data-option-length]');

  /**
   * Functions
   */
  const addIntersectionObserver = () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          node.classList.add('-translate-y-full');
          node.addEventListener(
            'transitionend',
            () => {
              if (node.classList.contains('-translate-y-full')) {
                node.classList.add('hidden');
              }
            },
            { once: true }
          );
        } else {
          const buttonRect = addToCartButton.getBoundingClientRect();
          if (buttonRect.top < 0) {
            node.classList.remove('hidden');
            setTimeout(() => {
              node.classList.remove('-translate-y-full');
            }, 10);
          }
        }
      });
    });

    if (observer && addToCartButton) observer.observe(addToCartButton);
  };

  const updateSelectedColor = (e) => {
    if (colorOption) colorOption.textContent = e.detail.color;
  };

  const updateSelectedSize = (e) => {
    if (lengthOption) lengthOption.textContent = e.detail.size;
  };

  /**
   * Init
   */
  const init = () => {
    addIntersectionObserver();

    if (popupAddToCartButton) {
      popupAddToCartButton.addEventListener('click', () => {
        const button = addToCartButton.querySelector('[button-add-to-cart]');
        button.click();
      });
    }
    document.addEventListener(
      'add-to-cart:selected-color-change',
      updateSelectedColor
    );

    document.addEventListener(
      'add-to-cart:selected-size-change',
      updateSelectedSize
    );
  };

  init();
};
